export const MarketIcon = (props: any) => (
  <svg
    width="76"
    height="76"
    viewBox="0 0 76 76"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M66.1245 39.121C62.3245 46.322 46.0225 58.824 40.1516 63.194C39.5377 63.6561 38.7918 63.9092 38.0235 63.916C37.2543 63.9147 36.5068 63.6611 35.8955 63.194C30.0245 58.824 13.7605 46.322 9.90352 39.121C7.62603 34.8846 7.0104 29.9511 8.17695 25.2849C9.3435 20.6187 12.2084 16.5553 16.2115 13.889C18.7563 12.2709 21.7079 11.4079 24.7235 11.4C27.3244 11.4345 29.8812 12.0761 32.1903 13.2735C34.4994 14.4709 36.4968 16.1911 38.0235 18.297C39.5471 16.1879 41.5439 14.4652 43.8536 13.2674C46.1634 12.0697 48.7219 11.4301 51.3236 11.4C54.3649 11.3945 57.3445 12.258 59.9115 13.889C63.9021 16.5668 66.7503 20.6368 67.8993 25.3031C69.0483 29.9694 68.4155 34.8965 66.1245 39.121Z"
      fill="#fff"
    />
  </svg>
);
